<template>
  <div class="flex justify-center min-h-screen mx-auto portrait:max-w-2xl landscape:max-w-4xl bg-slate-100 font-malar">
    <div class="flex-1 w-full portrait:max-w-2xl landscape:max-w-4xl">
      <router-view></router-view>
      <!-- <router-view v-slot="{ Component }">
        <keep-alive :exclude="['Login', 'Dashboard']">
          <component :is="Component" />
        </keep-alive>
      </router-view> -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'app',
  created() {
    let query = new URLSearchParams(window.location.search);

    if (query.get('dealer') != undefined) {
      window.localStorage.setItem('dealer_api_token', query.get('dealer'));
    }

    if (window.localStorage.getItem('dealer_user') != null) {
      this.$store.state.user = JSON.parse(window.localStorage.getItem('dealer_user'));
    }

    if (window.localStorage.getItem('dealer_api_token') != null) {
      this.$store.state.api_token = window.localStorage.getItem('dealer_api_token');
    }
  }
}
</script>
